import { observable, runInAction } from 'mobx'
import homeApi from '@api/xiu_yan/homeApi'
import { HLJ_MERCHANT_WORK_PLATFORM } from '@constant'
import { getJti } from '@util'

class Store {
  @observable shopInfo = {}

  getShopInfo = async () => {
    const { data, success } = await homeApi.shopInfo()

    runInAction(() => {
      if (success) {
        this.shopInfo = data
      }
    })
  }

  returnWorkPlatform = () => {
    // window.location.href = HLJ_MERCHANT_WORK_PLATFORM + getJti()
    // 凡跳转鉴权到商家中心均以新开标签页打开
    window.open(HLJ_MERCHANT_WORK_PLATFORM + getJti())
  }
}

export default Store
